import React, { memo } from "react";

const Iframe = memo(({ src }: { src: string }) => {
  return (
    <iframe
      src={src}
      width="100%"
      height="100%"
      style={{ border: 0 }}
      loading="lazy"
    ></iframe>
  );
});

export default Iframe;
